import React from "react";
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import {
  EVENT_CATEGORIES,
} from "../../../constants/automationEvents";

const TriggerStep = ({
  formData,
  onTriggerChange,
}) => {
  return (
    <Box sx={{ pt: 2 }}>
      {/* Trigger Event Label */}
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "0.85rem",
          color: "text.primary",
          mb: 1,
        }}
      >
        Trigger Event <span style={{ color: "#d32f2f" }}>*</span>
      </Typography>

      {/* Full-width Event Select */}
      <FormControl fullWidth size="small">
        <Select
          value={formData.trigger.event}
          onChange={(e) => onTriggerChange("event", e.target.value)}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return (
                <Typography sx={{ color: "text.disabled", fontSize: "0.85rem" }}>
                  Select an event...
                </Typography>
              );
            }
            const allEvents = EVENT_CATEGORIES.flatMap((c) => c.events);
            const evt = allEvents.find((e) => e.key === selected);
            return evt ? evt.label : selected;
          }}
          sx={{
            borderRadius: 1.5,
            fontSize: "0.85rem",
            bgcolor: "#F8FAFC",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "grey.200",
            },
          }}
        >
          {EVENT_CATEGORIES.map((category) => [
            <MenuItem disabled key={category.value} value="">
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  textTransform: "uppercase",
                  fontSize: "0.65rem",
                  letterSpacing: 1,
                  color: "text.secondary",
                }}
              >
                {category.label}
              </Typography>
            </MenuItem>,
            ...category.events.map((event) => (
              <MenuItem
                key={event.key}
                value={event.key}
                sx={{ fontSize: "0.82rem", py: 0.8 }}
              >
                {event.label}
              </MenuItem>
            )),
          ])}
        </Select>
      </FormControl>
    </Box>
  );
};

export default TriggerStep;
